import { render } from "./administradores.vue?vue&type=template&id=e24aa8c6"
import script from "./administradores.vue?vue&type=script&lang=js"
export * from "./administradores.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\reclasin-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__